import { SvgIcon, useTheme } from "@mui/material";
import { styled } from "@mui/material/styles";
import NotificationIcon from "./NotificationIcon";
import HomeIcon from "./HomeIcon";
import GearIcon from "./GearIcon";
import ExploreTemplateIcon from "./ExploreTemplateIcon";
import MyWorkIcon from "./MyWorkIcon";
import RightArrowIcon from "./RightArrowIcon";
import { TickIcon } from "./TickIcon";
import { WatchIcon } from "./WatchIcon";
import CrossIcon from "./CrossIcon";
import InfoIcon from "./InfoIcon";
import { CrownIcon } from "./CrownIcon";
import { FilterIcon } from "./filterIcon";

export const AppIcon = ({ iconName, fill, ...otherProps }) => {
  const StyledSvgIcon = styled(SvgIcon)((theme) => ({
    fill: fill,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }));

  const getIcon = () => {
    switch (iconName) {
      case "notification":
        return <NotificationIcon fill={fill} />;
      case "my-work":
        return <MyWorkIcon fill={fill} />;
      case "explore-template":
        return <ExploreTemplateIcon fill={fill} />;
      case "home":
        return <HomeIcon fill={fill} />;
      case "gear-icon":
        return <GearIcon fill={fill} />;
      case "right-arrow":
        return <RightArrowIcon fill={fill} />;
      case "tick":
        return <TickIcon fill={fill} />;
      case "watch":
        return <WatchIcon fill={fill} />;
      case "cross":
        return <CrossIcon fill={fill} />;
      case "info":
        return <InfoIcon fill={fill} />;
      case "crown":
        return <CrownIcon fill={fill} />;
      case "filter":
        return <FilterIcon fill={fill} />;
      default:
        break;
    }
  };
  return (
    <StyledSvgIcon component="span" {...otherProps}>
      {getIcon()}
    </StyledSvgIcon>
  );
};
